import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './i18n' // Initialize i18n
import App from './App'
import { initSentry } from './services/monitoring/Sentry'

initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)